/**
 * Normaliza una ruta de archivo para uso con Capacitor Filesystem.
 * En nativo (Android), WriteFileResult.uri retorna rutas absolutas
 * (file:///data/.../files/{type}/{name}) pero getUri() y stat()
 * esperan rutas relativas ({type}/{name}).
 */
export function normalizeFilePath(rawPath: string): string {
  if (!rawPath) return rawPath;
  if (!rawPath.startsWith('file://')) return rawPath;
  const idx = rawPath.indexOf('/files/');
  if (idx !== -1) return rawPath.slice(idx + 7);
  const segments = rawPath.split('/');
  return segments.slice(-2).join('/');
}
